/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_FertilizersInputs */

const vi_care_log_fertilizers = /** @type {(inputs: Care_Log_FertilizersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bón sử dụng`)
};

/**

* @param {Care_Log_FertilizersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_fertilizers = /** @type {((inputs?: Care_Log_FertilizersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_FertilizersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_fertilizers(inputs)
});